(function () {
  const body = document.body;
  if (!body.classList.contains('has-thematic-animations')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const template = body.dataset.template || '';
  if (template === 'gift_card' || template === 'cart') return;

  const mouse = document.createElement('div');
  mouse.className = 'thematic-edge-mouse';
  mouse.setAttribute('aria-hidden', 'true');
  mouse.innerHTML =
    '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="18" viewBox="0 0 28 18" fill="none" aria-hidden="true">' +
    '<ellipse cx="14" cy="11" rx="10" ry="7" fill="currentColor" opacity="0.82"/>' +
    '<circle cx="21.5" cy="6" r="3.2" fill="currentColor" opacity="0.82"/>' +
    '<path d="M5 11 Q3 13 1.5 15.5" stroke="currentColor" stroke-width="1.1" opacity="0.45" fill="none" stroke-linecap="round"/>' +
    '</svg>';

  document.body.appendChild(mouse);

  const scheduleNext = () => {
    const delayMs = 20000 + Math.random() * 40000;
    window.setTimeout(runLap, delayMs);
  };

  const runLap = () => {
    const durationMs = 2200 + Math.random() * 1800;
    mouse.style.setProperty('--mouse-duration', `${durationMs}ms`);
    mouse.classList.add('is-visible', 'is-running');
    window.setTimeout(() => {
      mouse.classList.remove('is-visible', 'is-running');
      scheduleNext();
    }, durationMs + 450);
  };

  window.setTimeout(runLap, 8000 + Math.random() * 7000);
})();
